<chitin-button
  class="col-auto"
  color="secondary"
  [size]="size()"
  [label]="dateRange()?.presetDisplayValue ?? dateRangeFormatted() ?? placeholder()"
  icon="fa-solid fa-calendar-alt"
  [isLoading]="isLoading()"
  [disabled]="isDisabled()"
  [ngbPopover]="daterangePickerPopover"
  placement="bottom-left"
  #pickerPopover="ngbPopover"
  (clicked)="pickerPopover.open()"
  [autoClose]="'outside'"
  popoverClass="pickerPopover"
  [container]="$any(appendTo())"
/>
<ng-template #daterangePickerPopover>
  <div class="popover-body">
    <div class="modal-body">
      <app-daterange-picker
        class="col-auto"
        [(dateRange)]="dateRange"
        [dateFormat]="dateFormat()"
        [minDate]="minDate()"
        [maxDate]="maxDate()"
      />
    </div>
  </div>
</ng-template>
